import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpacebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSpacebar"><Path d="M2.5 13V19.5H21.5V13" stroke="currentColor"/></CentralIconBase>;
});

export default IconSpacebar;
